export class ChaseAdvancePaymentTransactionStatus {
    transactionStatus: string;
    transactionId: string;
    advanceAmount: string;
    stationName: string;
    accountExecutiveName: string;
    agencyId: string;
    paymentMode: string;
}



// WEBPACK FOOTER //
// ./src/app/external-user/advance-details/advance-payment-status/Model/ChaseAdvancePaymentTransactionStatus.ts